import React from 'react';
import Tophead from '../templates/tophead';
function Aboutus(){
    return(
      <div>
         <Tophead/>
         asadf
      </div>
    )
}
export default Aboutus;